import React from 'react';
import Gene20Box from '../../Components/Gene20Box/Gene20Box';
import LPAppBar from './components/landingPageAppBar';
import { Container, CssBaseline, Toolbar } from '@mui/material';
import WelcomeNote from './components/welcomeNote';
import LPNavButtons from './components/navigationButtons';
import LPBillBoard from './components/landingPageBillboard';
import ParticlesBg from 'particles-bg';
import Gene20Footer from '../../Examples/Gene20Footer';
import jozi from '../../Assets/Images/joziLandscape.jpg';
// import SignIn from '../../Components/aunth/signIn/signIn';
// import SwipeableTextMobileStepper from '../../Components/gene20Carousel/carouselMUI';

export default function LandingPage(props) {
  const { auntheticated } = props;
  return (
    <Gene20Box
      sx={{
        width: '100%',
        background: '#0000ff22',
      }}
    >
      <CssBaseline />
      <LPAppBar />
      <Gene20Box sx={{ position: 'absolute', margin: 0, padding: 0, height: '100%' }}>
        <ParticlesBg
          num={30}
          density={500}
          type="balls"
          color="#030303"
          bg={{
            zIndex: -99,
            width: '100%',
            height: '100vh',
            opacity: '0.8',
            margin: 0,
            padding: 0,
          }}
        />
      </Gene20Box>
      <Gene20Box
        component={Container}
        sx={{
          width: '100%',
          height: '100vh',
          display: { sm: 'flex' },
          justifyContent: 'space-between',
          justifyItems: 'center',
          alignItems: 'center',
          // backgroundImage: `url(${jozi})`,
          // backgroundPosition: 'center',
          // backgroundRepeat: 'no-repeat',
          // backgroundSize: 'cover',
          // zIndex: -99,
        }}
      >
        <Gene20Box item xs={12} sm={6} sx={{ display: 'block', width: { sm: '50vw' } }}>
          <LPBillBoard />
        </Gene20Box>
        <Gene20Box item xs={12} sm={6} sx={{ p: 2, display: 'block' }}>
          <WelcomeNote />
          <LPNavButtons auntheticated={auntheticated} />
        </Gene20Box>
      </Gene20Box>
      <Gene20Footer />
    </Gene20Box>
  );
}
